export default __webpack_public_path__ + "all-categories.00e1983fc26d72bd238638b6c621c320.png";